<template>
  <div>
    <div
      id="thanksModal"
      class="modal fade"
      data-focus="false"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-scrollable">
        <ValidationObserver
          ref="letter"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <div class="letter-modal">
            <div class="note-wrap">
              <div class="letter-title">感謝函</div>

              <div class="note-title">可動態套入信件內容，請參考以下參數</div>
              <div class="note-table">
                <table v-if="mailParameters">
                  <tr v-for="(parameter, index) in mailParameters" :key="index">
                    <th>{{ parameter.MailParameterName }}</th>
                    <td>
                      <span> {{</span>{{ parameter.MailParameterCode
                      }}<span>}} </span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <form @reset.prevent="reset">
              <div class="modal-content border-0">
                <perfect-scrollbar class="modal-body">
                  <div v-if="mail.Name" class="form-group">
                    <label for="exampleInputEmail1">姓名：</label>
                    <span>{{ mail.Name }}</span>
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">應徵職務：</label>
                    <span>{{ mail.Position }}</span>
                  </div>
                  <div class="form-group">
                    <label for=""> 信件範本： </label>
                    <select
                      class="form-control w-100"
                      @change="getMailTemplateDetail"
                      v-model="selectedTemplateGuid"
                    >
                      <option :value="null" disabled>請選擇</option>
                      <option
                        v-for="template in mailTemplates"
                        :key="template.MailTemplateGuid"
                        :value="template.MailTemplateGuid"
                      >
                        {{ template.MailTemplateName }}
                      </option>
                    </select>
                  </div>

                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="信件主旨"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for=""> <span class="mark">*</span>信件主旨： </label>
                      <input
                        placeholder="請輸入信件主旨或選擇範本"
                        class="form-control w-100"
                        v-model="mail.MailSubject"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="form-group">
                    <ValidationProvider
                      rules="required"
                      name="信件內容"
                      class="w-100"
                      v-slot="{ errors }"
                    >
                      <label for=""> <span class="mark">*</span>信件內容： </label>
                      <VueEditor
                        style="background: rgb(255, 255, 255)"
                        v-model="mail.MailTemplateBody"
                      />
                      <p class="text-danger" style="font-size: 13px">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                </perfect-scrollbar>

                <div class="modal-footer">
                  <button
                    type="reset"
                    class="btn btn-secondary"
                    aria-label="關閉"
                    @click="closeThanksMailModal"
                  >
                    取消
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="handleSubmit(preview)"
                  >
                    預覽
                  </button>
                  <button
                    type="button"
                    class="btn btn-success"
                    :disabled="clickDisabled"
                    @click="handleSubmit(thanksMail)"
                  >
                    寄出
                  </button>
                </div>
              </div>
            </form>
          </div>
        </ValidationObserver>
      </div>
    </div>

    <!-- 預覽 Modal -->
    <PreviewMailModal type="thanks" :mail="mail" />
  </div>
</template>

<script>
/* global $ */
import { mapGetters, mapActions } from "vuex";
import PreviewMailModal from "@/components/back/Modal/PreviewMailModal.vue";

export default {
  props: ["personData"],

  name: "ThanksMailModal",
  components: {
    PreviewMailModal,
  },
  data() {
    return {
      // 範本
      mailParameters: {},
      mailTemplates: [],

      // 所選擇範本的 guid
      selectedTemplateGuid: null,

      // 信件內容
      mail: {},

      // 寄出按鈕
      clickDisabled: false,
    };
  },

  computed: {
    ...mapGetters(["showThanksMail"]),
  },

  watch: {
    showThanksMail: function (e) {
      if (e) {
        this.selectedTemplateGuid = null;
        this.mail = {
          Name: this.personData.Name,
          Position: this.personData.Position,
          MatchIds: this.personData.MatchId,
          MailSenderGuid: this.$cookies.get("userId"),
        };
        this.$refs.letter.reset();
        this.clickDisabled = false;
        $("#thanksModal").modal("show");
      } else {
        $("#thanksModal").modal("hide");
      }
    },
  },

  methods: {
    // 感謝函
    thanksMail() {
      this.clickDisabled = true;
      this.updateLoading(true);

      this.$api.sendmail
        .thanksMail({ ...this.mail })
        .then((response) => {
          if (response.status === 200) {
            this.clickDisabled = false;
            this.updateLoading(false);
            this.$store.commit("OpenThanksMailModal", false);
            this.$notify({
              title: "成功",
              message: "已寄出感謝函",
              type: "success",
              duration: 2000,
            });
            this.$emit("clearSelectCard");
            this.$emit("getLatestSearchResult");
          }
        })
        .catch(() => {
          this.clickDisabled = false;
          this.updateLoading(false);
        });
    },

    // 依guid 取得信件範本內容
    getMailTemplateDetail() {
      this.updateLoading(true);
      this.$api.mailTemplate
        .getMailTemplateDetail(this.selectedTemplateGuid)
        .then((response) => {
          if (response.status === 200) {
            this.$set(
              this.mail,
              "MailSubject",
              response.data.MailTemplateSubject
            );
            this.$set(
              this.mail,
              "MailTemplateBody",
              response.data.MailTemplateBody
            );
          }
          this.updateLoading(false);
        });
    },

    // 預覽
    preview() {
      this.$store.commit("OpenPreviewMailModal", true);
    },

    // 點擊取消
    closeThanksMailModal() {
      this.$store.commit("OpenThanksMailModal", false);
    },

    async getData() {
      await this.$http
        .all([
          this.$api.mailTemplate.getMailParameter(
            "52CCC749-F7B9-45F6-94A8-C89778DDA276"
          ),
          this.$api.mailTemplate.getMailTemplatePaging(
            { isPaging: false },
            "Thanks"
          ),
        ])
        .then(
          this.$http.spread((parameter, template) => {
            // 取得 信件參數
            this.mailParameters = parameter.data;
            // 取得 信件範本
            this.mailTemplates = template.data.Datas;
          })
        );
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
    this.$store.commit("OpenThanksMailModal", false);
  },
};
</script>

<style lang="scss" scoped>
#thanksModal {
  .modal-dialog {
    max-width: 960px;
    .modal-content {
      background-color: transparent;
      border: none;
    }
  }
}
</style>
